import React from "react";
import { toast } from "sonner";
import { Droplets, Copy, ExternalLink } from "lucide-react";
import { Panel, Pill } from "@/components/croc/ui";
import { usePolling } from "@/components/croc/hooks";
import { fmtUsd } from "@/lib/format";
import { CHAIN } from "@/contracts/croc";
import api from "@/lib/api";

export const LiquidityPoolCard = () => {
  const { data } = usePolling(() => api.liquidityPool(), [], 30000);
  if (!data?.address) return null;
  const copy = () => {
    navigator.clipboard.writeText(data.address);
    toast.success("Contract address copied");
  };
  return (
    <Panel className="mt-6 mb-6" data-testid="liquidity-pool-card">
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-11 h-11 rounded-xl bg-[#1CFD4C]/12 border border-[#1CFD4C]/30 grid place-items-center shrink-0">
            <Droplets className="w-5 h-5 emerald-text" />
          </div>
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <span className="font-display font-bold text-lg text-white">Liquidity Pool Contract</span>
              <Pill tone="emerald" className="text-[10px]">Live On-Chain</Pill>
            </div>
            <div className="flex items-center gap-2 mt-1 min-w-0">
              <span className="font-num text-xs text-muted-foreground break-all" data-testid="liquidity-pool-address">{data.address}</span>
              <button onClick={copy} data-testid="liquidity-pool-copy-btn" title="Copy address"
                className="text-muted-foreground hover:text-white transition-colors shrink-0">
                <Copy className="w-3.5 h-3.5" />
              </button>
              <a href={`${CHAIN.explorer}/address/${data.address}`} target="_blank" rel="noreferrer"
                data-testid="liquidity-pool-bscscan-link" title="View on BscScan"
                className="text-muted-foreground hover:text-white transition-colors shrink-0">
                <ExternalLink className="w-3.5 h-3.5" />
              </a>
            </div>
          </div>
        </div>
        <div className="rounded-xl border border-[#1CFD4C]/25 bg-[#1CFD4C]/[0.05] px-5 py-3 lg:text-right shrink-0">
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Live USDT Balance</div>
          <div className="font-num font-black text-2xl emerald-text" data-testid="liquidity-pool-balance">
            {data.usdt_balance === null || data.usdt_balance === undefined ? "—" : fmtUsd(data.usdt_balance)}
          </div>
        </div>
      </div>
    </Panel>
  );
};
